import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: 6,
    background: '#0EA5E9',
  },
  text: {
    color: '#FFFFFF',
    fontWeight: 800,
    fontSize: '0.85rem',
    letterSpacing: '-0.03em',
    lineHeight: 1,
  },
});

const LogoIcon = () => {
  const classes = useStyles();
  return (
    <span className={classes.root}>
      <span className={classes.text}>ET</span>
    </span>
  );
};

export default LogoIcon;
